module.exports = __webpack_public_path__ + "img/map.b95768f3.jpg";